let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("8U6t0")).then(() => parcelRequire('6Achf'));